module.exports = __webpack_public_path__ + "img/shortcut-kingdee.b722a5d1.png";